import { getOrderItemCountByItemId } from '../../selectors/items/get-order-item-count-by-item-id';
import { getPriceRestrictionFromItemPrice } from '../../selectors/items/get-price-restriction-from-item-price';
import { updateInProgressItemQuantity } from './update-in-progress-item-quantity';
export const createInProgressItemsFromOrderItems = (sellableItem, itemPrice) => {
    const priceRestriction = itemPrice ? getPriceRestrictionFromItemPrice(itemPrice) : undefined;
    /**
     * When creating in-progress items from order items, we need to filter them out by price restriction ids (also filters out an array
     * of items that don't have any price restrictions).
     * In this way, all other items will remain unaffected that were not added with the same item price restriction.
     */
    const orderItemCount = getOrderItemCountByItemId(sellableItem.itemId, priceRestriction) || 1;
    /**
     * When converting order items to inProgress items, there will initially be no in-progress item in the store.
     * The updateInProgressItemQuantity() creates in-progress items if none exists.
     */
    updateInProgressItemQuantity(sellableItem, orderItemCount, itemPrice);
};
